export class ConsultaJuc {
    tipoConsulta:string;
    consulta: string;
    respuesta:string;
  }


// WEBPACK FOOTER //
// ./src/app/juc/dto/consulta-juc.model.ts